import { isProd, isDev } from 'constants/env';

export const getCustomerUrl = () => {
  if (isProd()) {
    return `https://www.wingalpha.com/`;
  } else if (isDev()) {
    return `https://customer-dev.wingalpha.com/`;
  } else {
    return `https://customer-stage.wingalpha.com/`;
  }
};
